export function chunck<T>(list: T[], size: number): T[][] {
    const result = []
    let startIndex = 0
    while (startIndex < list.length) {
        const slice = list.slice(startIndex, startIndex + size)
        result.push(slice)
        startIndex = startIndex + size
    }
    return result
}